

export const SET_LICENSES = 'SET_LICENSES'
export const SET_RESUME = 'SET_RESUME'
export const SET_RESUME_LICENSES = 'SET_RESUME_LICENSES'
export const SET_RESUME_CHARTERS = 'SET_RESUME_CHARTERS'
export const SET_IYT_LICENSES = 'SET_IYT_LICENSES'
export const SET_SHARED_RESUME = 'SET_SHARED_RESUME'
export const SET_FAVORITES_YACHTS = 'SET_FAVORITES_YACHTS'
export const SET_TEAM = 'SET_TEAM'

export const SET_IS_MORE_LICENSES = 'SET_IS_MORE_LICENSES'
export const SET_IS_MORE_YACHTS = 'SET_IS_MORE_YACHTS'
export const SET_IS_MORE_TEAM = 'SET_IS_MORE_TEAM'
